<template>
  <div class="w-full" :key="reRenderKey">
    <div v-if="shownAlert" class="mb-12">
      <zt-alert :color="statusAlert" close-icon filled @afterClosed="shownAlert = false" class="message px-3 py-3">
        <div slot="custom-content">
          <div class="flex justify-start items-center">
            <zt-icon v-if="iconName" :name="iconName" class="icon mr-3"></zt-icon>
            <p class="mr-4">{{ messageAlert }}</p>
          </div>
        </div>
      </zt-alert>
    </div>

    <template v-if="getCompanyCountry === 'PE'">
      <div>
        <h2 class="custom-account-title custom-color-gray font-medium mb-4">{{ $t("message.DocumentsComponents.account") }}</h2>
        <div class="w-full custom-input mb-12">
          <ValidationProvider ref="fieldNameBankPeSueldo"
            :rules="{ regex: /^[0-9a-zA-Z-À-ú-\s]+$/, min: 3, max: 150, required: true }"
            v-slot="{ errors, failedRules, invalid }">
            <zt-input v-model="params.name_bank" class="w-full" color="primary" outlined data-vs-input="name-bank-pe"
              :label="$t('message.selfService.fields.nameBank')" />
            <validation-message :rules="{ errors, failedRules, invalid, fieldName: 'nameBank' }" />
          </ValidationProvider>
        </div>
        <div class="w-full custom-input mb-12">
          <ValidationProvider ref="fieldNameCuentaSueldo"
            :rules="{ regex: /^[0-9a-zA-Z-À-ú-\s]+$/, min: 10, max: 18, required: true }"
            v-slot="{ errors, failedRules, invalid }">
            <zt-input v-model="params.account_number" class="w-full" name="nb-folder" color="primary"
              data-vs-input="cuenta-sueldo" outlined :label="$t('message.selfService.fields.cuentaBancaria')" />
            <validation-message :rules="{ errors, failedRules, invalid, fieldName: 'cuentaBancariaSueldo' }" />
          </ValidationProvider>
        </div>
        <div class="w-full custom-input mb-12">
          <ValidationProvider ref="fieldNameCuentaSueldoCci"
            :rules="{ regex: /^[0-9a-zA-Z-À-ú-\s]+$/, min: 20, max: 20, required: true, is_cci: `${params.cbu}`, cci_length: `${params.cbu}` }"
            v-slot="{ errors, failedRules, invalid }">
            <zt-input v-model="params.cbu" class="w-full" name="nb-folder" color="primary"
              data-vs-input="cuenta-sueldo-cci" outlined :label="$t('message.selfService.fields.cuentaCci')" />
            <validation-message :rules="{ errors, failedRules, invalid, fieldName: 'cuentaSueldoCci' }" />
          </ValidationProvider>
        </div>
        <div class="w-full custom-input mb-12">
          <ValidationProvider ref="fieldTypeAccountSueldo"
            :rules="{ regex: /^[0-9a-zA-Z-À-ú-\s]+$/, min: 3, max: 150, required: true }"
            v-slot="{ errors, failedRules, invalid }">
            <zt-input v-model="params.account_type" class="w-full" name="nb-folder" color="primary" outlined
              :label="$t('message.selfService.fields.typeAccount')" data-vs-input="type-account-sueldo" />
            <validation-message :rules="{ errors, failedRules, invalid, fieldName: 'typeAccount' }" />
          </ValidationProvider>
        </div>
      </div>
      <div>
        <h2 class="custom-account-title custom-color-gray font-medium mb-4">{{
          $t("message.DocumentsComponents.ctsAccount") }}</h2>
        <div class="w-full custom-input mb-12">
          <ValidationProvider ref="fieldNameBankPeCts"
            :rules="{ regex: /^[0-9a-zA-Z-À-ú-\s]+$/, min: 3, max: 150, required: true }"
            v-slot="{ errors, failedRules, invalid }">
            <zt-input v-model="params.name_bank_cts" class="w-full" color="primary" outlined
              data-vs-input="name-bank-pe" :label="$t('message.selfService.fields.nameBank')" />
            <validation-message :rules="{ errors, failedRules, invalid, fieldName: 'nameBank' }" />
          </ValidationProvider>
        </div>
        <div class="w-full custom-input mb-12">
          <ValidationProvider ref="fieldNameCuentaCts"
            :rules="{ regex: /^[0-9a-zA-Z-À-ú-\s]+$/, min: 10, max: 18, required: true }"
            v-slot="{ errors, failedRules, invalid }">
            <zt-input v-model="params.account_number_cts" class="w-full" name="nb-folder" color="primary"
              data-vs-input="cuenta-cts" outlined :label="$t('message.selfService.fields.cuentaBancaria')" />
            <validation-message :rules="{ errors, failedRules, invalid, fieldName: 'cuentaBancariaCts' }" />
          </ValidationProvider>
        </div>
        <div class="w-full custom-input mb-12">
          <ValidationProvider ref="fieldNameCuentaCtsCci"
            :rules="{ regex: /^[0-9a-zA-Z-À-ú-\s]+$/, min: 20, max: 20, required: true, is_cci: `${params.cbu_cts}`, cci_length: `${params.cbu_cts}` }"
            v-slot="{ errors, failedRules, invalid }">
            <zt-input v-model="params.cbu_cts" class="w-full" name="nb-folder" color="primary"
              data-vs-input="cuenta-cts-cci" outlined :label="$t('message.selfService.fields.cuentaCci')" />
            <validation-message :rules="{ errors, failedRules, invalid, fieldName: 'cuentaCtsCci' }" />
          </ValidationProvider>
        </div>
        <div class="w-full custom-input mb-12">
          <ValidationProvider ref="fieldTypeAccountCts"
            :rules="{ regex: /^[0-9a-zA-Z-À-ú-\s]+$/, min: 3, max: 150, required: true }"
            v-slot="{ errors, failedRules, invalid }">
            <zt-input v-model="params.account_type_cts" class="w-full" name="nb-folder" color="primary" outlined
              :label="$t('message.selfService.fields.typeAccount')" data-vs-input="type-account-cts" />
            <validation-message :rules="{ errors, failedRules, invalid, fieldName: 'typeAccount' }" />
          </ValidationProvider>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="w-full custom-input mb-12">
        <ValidationProvider ref="fieldNameBank" :rules="{ regex: /^[0-9a-zA-Z-À-ú-\s]+$/, min: 3, max: 150 }"
          v-slot="{ errors, failedRules, invalid }">
          <zt-input v-model="params.name_bank" class="w-full" color="primary" outlined data-vs-input="name-bank"
            :label="$t('message.selfService.fields.nameBank')" />
          <validation-message :rules="{ errors, failedRules, invalid, fieldName: 'nameBank' }" />
        </ValidationProvider>
      </div>
      <div class="w-full custom-input mb-12">
        <ValidationProvider ref="fieldNameCBU"
          :rules="{ regex: /^[0-9a-zA-Z-À-ú-\s]+$/, min: 3, ...(isArg ? { cbu_length: `${params.cbu}`, is_cbu: `${params.cbu}` } : { max: 35 }) }"
          v-slot="{ errors, failedRules, invalid }">
          <zt-input v-model="params.cbu" class="w-full" name="nb-folder" color="primary" data-vs-input="cbu" outlined
            :label="$t('message.selfService.fields.cuentaBancaria')" />
          <validation-message :rules="{ errors, failedRules, invalid, fieldName: 'cbu' }" />
        </ValidationProvider>
      </div>
      <div class="w-full custom-input mb-12">
        <ValidationProvider ref="fieldTypeAccount" :rules="{ regex: /^[0-9a-zA-Z-À-ú-\s]+$/, min: 3, max: 20 }"
          v-slot="{ errors, failedRules, invalid }">
          <zt-input v-model="params.account_type" class="w-full" name="nb-folder" color="primary" outlined
            :label="$t('message.selfService.fields.typeAccount')" data-vs-input="type-account" />
          <validation-message :rules="{ errors, failedRules, invalid, fieldName: 'typeAccount' }" />
        </ValidationProvider>
      </div>
    </template>

    <!-- Cancel and Approve Section -->
    <div class="flex justify-end w-full">
      <zt-button v-if="pendingApprove" @click="cancelDialog = true" data-vs-button="cancel-request">{{
        $t("message.licenseComponent.licenseBox.cancel") }}</zt-button>
      <zt-button v-else :disabled="isNotAvailable" :loader="isLoading" @click="save" data-vs-button="save-request">
        {{ $t('message.selfService.actions.save') }}
      </zt-button>
    </div>

    <self-service-cancel-dialog v-if="pendingApprove" :active="cancelDialog" @close-modal="closeModal"
      @confirm="cancelRequest" />
  </div>
</template>

<script>
import { isEqual, defaults } from 'lodash'
import Users from '@/apiClient/Users'
import ValidationMessage from '../generic/ValidationMessage'
import SelfServiceCancelDialog from './SelfServiceCancelDialog'
import parseNull from '@/utils/parseNull'
import { extend } from 'vee-validate'
import { isValidCBU, _isLengthCBU } from '@/utils/validateCBU'
import { validateCCI, validateAccountInCci, validateCCILength } from '@/utils/bankAccountPeru';
import { mapGetters } from 'vuex'

const icons = {
  'danger': 'exclamation-circle-solid',
  'info': 'info-circle-solid'
}

extend('is_cbu', {
  validate: (value) => {
    return isValidCBU(value)
  },
  message: ''
})
extend('cbu_length', {
  validate: (value) => {
    return _isLengthCBU(value)
  },
  message: ''
})

extend('cci_length', {
  validate: (value) => {
    return validateCCILength(value)
  },
  message: ''
})

extend('is_cci', {
  validate: (value) => {
    return validateCCI(value)
  },
  message: ''
})

export default {
  name: "SelfServiceDataBank",
  components: { ValidationMessage, SelfServiceCancelDialog },
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    updateFn: {
      type: Function,
      default: () => { }
    }
  },
  data() {
    return {
      isLoading: false,
      isNotAvailable: true,
      params: {
        cbu: '',
        name_bank: '',
        account_type: ''
      },
      pendingApprove: false,
      shownAlert: false,
      statusAlert: 'info',
      messageAlert: '',
      cache: {},
      cancelDialog: false,
      cancelRequesting: false,
      reRenderKey: 0
    }
  },
  watch: {
    params: {
      async handler(newParams) {
        if (this.info.pending && !isEqual(this.cache, this.params)) this.pendingApprove = false
        else this.pendingApprove = this.info.pending
        for (const [key] of Object.entries(newParams)) {
          if (key) {
            const isError = await this.checkFieldError()
            this.isNotAvailable = isError || isEqual(this.cache, this.params)
            if (isError) break
          }
        }
      },
      deep: true
    },
    info() {
      this.infoUpdate()
    }
  },
  computed: {
    ...mapGetters(['getCompanyCountry']),
    iconName() {
      return icons[this.statusAlert]
    },
    isArg() {
      return this.$store.state.user.pais === 'AR'
    }
  },
  created() {
    this.userApi = new Users()
    this.infoUpdate()
  },
  methods: {
    async save() {
      if (this.isNotAvailable) return
      this.isLoading = true
      this.shownAlert = false
      const body = this.params
      if (body.id) delete body.id
      if ('sichernpeople' in body) delete body.sichernpeople

      if (this.getCompanyCountry === 'PE') {


        if (!validateAccountInCci(this.params.account_number, this.params.cbu) || !validateAccountInCci(this.params.account_number_cts, this.params.cbu_cts)) {
          this.messageAlert = this.$t("message.licenseComponent.licenseBox.cciAccountInvalid")
          this.shownAlert = true
          this.statusAlert = 'danger'
          this.isLoading = false

          return false
        }

        body.payment_type = 'Sueldo'
        body.payment_type_cts = 'CTS'
      }

      try {
        await this.userApi.saveBankInfo(body)
        await this.updateFn()
        this.isLoading = false
        this.isNotAvailable = true
        this.shownAlert = true
        this.statusAlert = 'info'
        this.messageAlert = this.$t('message.selfService.response.success')
      } catch (e) {
        if (e.response.status === 404) {
          this.messageAlert = this.$t(`message.selfService.response.errors.notFound`)
        } else {
          const code = e.response.data.codes[0].code
          this.messageAlert = this.$t(`message.selfService.response.errors.${code}`)
        }
        this.isLoading = false
        this.isNotAvailable = false
        this.shownAlert = true
        this.statusAlert = 'danger'
      }
    },
    async checkFieldError() {
      for (const [, provider] of Object.entries(this.$refs)) {
        if (provider) {
          const { valid } = await provider.validate()
          if (!valid) return true
        }
      }
      return false
    },
    infoUpdate() {
      const { pending, ...rest } = this.info
      this.cache = parseNull({ ...rest })
      this.params = parseNull({ ...rest })
      this.pendingApprove = pending
      this.messageAlert = this.$t('message.selfService.response.success')
      this.statusAlert = 'info'
      this.shownAlert = pending
      this.reRenderKey += 1

      if (this.getCompanyCountry === 'PE') {
        this.initialStatePeru()
      }
    },
    initialStatePeru() {
      const state = {
        name_bank_cts: '',
        account_number: '',
        account_number_cts: '',
        cbu_cts: '',
        account_type_cts: '',
        payment_type: 'Sueldo',
        payment_type_cts: 'CTS',

      }

      const initialDefaults = defaults(this.params, state)

      this.params = { ...initialDefaults }
      this.cache = { ...initialDefaults }
    },
    async cancelRequest() {
      this.cancelRequesting = true
      try {
        await this.userApi.cancelSelfServiceRequest(this.info.id)
        await this.updateFn()
        this.cancelRequesting = false
        this.closeModal()
        this.messageAlert = this.$t('message.selfService.response.successCancel')
        this.statusAlert = 'info'
        this.shownAlert = true
      } catch (e) {
        if (e.response.status === 404) {
          this.messageAlert = this.$t(
            `message.selfService.response.errors.notFound`
          )
        } else {
          const code = e.response.data.codes[0].code
          this.messageAlert = this.$t(
            `message.selfService.response.errors.${code}`
          )
        }
        this.isLoading = false
        this.isNotAvailable = false
        this.shownAlert = true
        this.statusAlert = 'danger'
        this.cancelRequesting = false
        this.closeModal()
      }
    },
    closeModal() {
      if (this.cancelRequesting) return
      this.cancelRequesting = false
      this.cancelDialog = false
    }
  }
}
</script>

<style scoped lang="scss">
.icon {
  font-size: 2rem;
}

p {
  font-size: 1rem;
}

::v-deep {
  .message .zt-icon-times {
    margin-top: 16px;
  }
}

.custom-input {
  ::v-deep {
    .zt-label.zt-label-active {
      background: #FFFF !important;
      padding: 2px !important;
    }

    .zt-input {
      font-size: 1.125rem;
    }
  }
}

::v-deep {}

.custom-account-title {
  font-size: 1.2rem;
}
</style>